import {useCallback, useState, useSyncExternalStore} from "react";
import {useSecurityClient} from "./SecurityClientProvider";
import {AuthenticationOptions, AuthenticationObserver, AuthenticationObserverResult} from "../core";


export function useAuthentication<TVariables = void, TPrincipal = unknown>(options: AuthenticationOptions<TVariables, TPrincipal>) {

    const client = useSecurityClient<TPrincipal>();
    const authenticationManager = client.authenticationManager;
    const [observer] = useState(() => {
        return new AuthenticationObserver<TVariables, TPrincipal>(
            authenticationManager,
            options
        )
    });

    const currentResult: AuthenticationObserverResult<TVariables, TPrincipal> = useSyncExternalStore(
        useCallback((onStoreChange) => {
            return observer.subscribe(onStoreChange)
        }, [observer]),
        () => observer.getCurrentResult()
    );
    return currentResult;
}